<template>
  <div class="title-border-section">
    <span class="l-title">{{title}}</span>
    <div class="right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleBorder',
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
.title-border-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .l-title {
    padding-left: 10px;
    position: relative;
    font-size: 18px;
    line-height: 18px;
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      content: '';
      width: 3px;
      background-color: var(--systemMainColor);
    }
  }
  .right {
    line-height: 18px;
  }
}
</style>
